(() => {
  if (window.KranTeamLinkedInEventsInitialized) return;
  window.KranTeamLinkedInEventsInitialized = true;

  document.addEventListener('click', (event) => {
    const phoneLink = event.target instanceof Element
      ? event.target.closest('a[href^="tel:"]')
      : null;

    if (!phoneLink || !window.Shopify?.analytics?.publish) return;

    Shopify.analytics.publish('kranteam:phone_clicked', {
      href: phoneLink.getAttribute('href'),
    });
  });
})();
